import { PayPalScriptProvider } from "@paypal/react-paypal-js"

import { Spinner } from "@trueskin-web/components"

import { PaypalButton } from "./paypal-button"
import { usePaypalClientToken } from "./use-paypal"

export const Paypal = ({ type, order }) => {
  const { intent, braintreeClientToken, isBraintreeClientTokenLoading } =
    usePaypalClientToken({
      order,
    })

  if (isBraintreeClientTokenLoading) {
    return (
      <div
        sx={{
          textAlign: "center",
        }}
      >
        <Spinner />
      </div>
    )
  }

  return (
    <PayPalScriptProvider
      options={{
        // debug: "true",
        "client-id": process.env.GATSBY_PAYPAL_CLIENT_ID,
        "data-user-id-token": braintreeClientToken,
        currency: order.currency,
        vault: true,
        intent,
      }}
    >
      <PaypalButton type={type} order={order} intent={intent} />
    </PayPalScriptProvider>
  )
}
